import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";

function DueDateSetup() {
  const [id, setId] = useState(0);
  const [registrationDueDays, setRegistrationDueDays] = useState("");
  const [admissionDueDays, setAdmissionDueDays] = useState("");
  const [periodicBillingDays, setPeriodicBillingDays] = useState("");
  const [processingDate, setProcessingDate] = useState(new Date());
  const [isActive, setIsActive] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dueDateSetups, setDueDateSetups] = useState([]);

  useEffect(() => {
    const fetchDueDateSetups = async () => {
      try {
        const response = await get("CommonSettings/GetChallanDueDateAsync");
        setDueDateSetups(response.challanDueDate);
      } catch (error) {
        console.error("Error fetching due date setups:", error);
      }
    };
    fetchDueDateSetups();
  }, []);

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const handleDateChange = (date) => {
    setProcessingDate(date);
    setShowCalendar(false);
  };

  const handleEditClick = async (rowId) => {
    try {
      const response = await get(
        `CommonSettings/GetChallanDueDateById?id=${rowId}`
      );
      const data = response.challanDueDate;
      setId(data.id);
      setRegistrationDueDays(data.registrationChallanDueDays?.toString() || "");
      setAdmissionDueDays(data.admissionChallanDueDays?.toString() || "");
      setPeriodicBillingDays(data.monthlyChallanDueDays?.toString() || "");
      setProcessingDate(new Date(data.monthlyChallanProcessingDate));
      setIsActive(data.isActive);
    } catch (error) {
      console.error("Error fetching due date setup:", error);
    }
  };

  // Save data by calling the specified API
  const saveData = async (e) => {
    e.preventDefault();
    const formData = {
      id,
      registrationChallanDueDays: registrationDueDays
        ? parseInt(registrationDueDays, 10)
        : null,
      admissionChallanDueDays: admissionDueDays
        ? parseInt(admissionDueDays, 10)
        : null,
      monthlyChallanDueDays: periodicBillingDays
        ? parseInt(periodicBillingDays, 10)
        : null,
      monthlyChallanProcessingDate: processingDate.toISOString(),
      isActive: isActive ? true : false,
    };

    try {
      const response = await post(
        "CommonSettings/AddUpdateChallanDueDateAsync",
        formData
      );
      if (response.isSuccess) {
        console.log("Data saved successfully:", response);

        const updatedResponse = await get("DueDateSetup/GetAllDueDateSetups");
        setDueDateSetups(updatedResponse);

        setId(0);
        setRegistrationDueDays("");
        setAdmissionDueDays("");
        setPeriodicBillingDays("");
        setProcessingDate(new Date());
        setIsActive(false);
      } else {
        console.error("Error from API:", response.message);
      }
    } catch (error) {
      console.error("Error saving due date setup:", error);
    }
  };

  const columns = [
    { name: "Sr No.", cell: (row, index) => index + 1, width: "60px" },
    {
      name: "Reg. Fee Due Days",
      selector: (row) => row.registrationChallanDueDays || "-",
    },
    {
      name: "Adm. Fee Due Days",
      selector: (row) => row.admissionChallanDueDays || "-",
    },
    {
      name: "Periodic Billing Days",
      selector: (row) => row.monthlyChallanDueDays || "-",
    },
    {
      name: "Processing Date",
      selector: (row) => row.monthlyChallanProcessingDate,
    },
    {
      name: "Is Active",
      selector: (row) => (row.isActive == true ? "Yes" : "No"),
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          type="button"
          className="btn p-0"
          onClick={() => handleEditClick(row.id)}
        >
          <i className="fas fa-pencil"></i>
        </button>
      ),
      width: "80px",
    },
  ];

  return (
    <div className="">
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Due Date Setup</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <form className="new-form-style" onSubmit={saveData}>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label
                      htmlFor="registrationDueDays"
                      className="form-label form-label-new"
                    >
                      Registration Fee Due Days
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="registrationDueDays"
                      value={registrationDueDays}
                      onChange={(e) => setRegistrationDueDays(e.target.value)}
                      min="0"
                      step="1"
                      placeholder="Enter days"
                    />
                  </div>
                  <div className="col-md-4">
                    <label
                      htmlFor="admissionDueDays"
                      className="form-label form-label-new"
                    >
                      Admission Fee Due Days
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="admissionDueDays"
                      value={admissionDueDays}
                      onChange={(e) => setAdmissionDueDays(e.target.value)}
                      min="0"
                      step="1"
                      placeholder="Enter days"
                    />
                  </div>
                  <div className="col-md-4">
                    <label
                      htmlFor="periodicBillingDays"
                      className="form-label form-label-new"
                    >
                      Periodic Billing Days
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="periodicBillingDays"
                      value={periodicBillingDays}
                      onChange={(e) => setPeriodicBillingDays(e.target.value)}
                      min="0"
                      step="1"
                      placeholder="Enter days"
                    />
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="processingDate"
                      className="form-label form-label-new"
                    >
                      Periodic Billing Processing Date
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={processingDate.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        })}
                        readOnly
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={toggleCalendar}
                      >
                        <i className="fas fa-calendar-alt"></i>
                      </button>
                    </div>
                    {showCalendar && (
                      <div className="mt-2">
                        <Calendar
                          value={processingDate}
                          onChange={handleDateChange}
                          minDate={new Date()}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="isActive" className="form-label">
                      Is Active
                    </label>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isActive"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary btn-sm">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={dueDateSetups}
                pagination={false}
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DueDateSetup;
